import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import './App.css';

import Form from './Form.js';
import SignUpForm from './SignUpForm.js';
import BusinessForm from './BusinessForm.js';
import TestForm from './TestForm.js';
import OrderDetails from './OrderDetails.js';
import Invoice from './Invoice.js';
import Business from './Business';
import BusinessPortal from './BusinessPortal.js';
import Calculator from './Calculator.js';
import OrderStatus from './OrderStatus';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/">
            <Form />
          </Route>
          <Route path="/signup">
            <SignUpForm />
          </Route>
          <Route path="/enterprise" render={ (props) => <BusinessForm {...props} /> } />
          <Route path="/enterprisePortal">
            <BusinessPortal />
          </Route>
          <Route path="/dev">
            <TestForm />
          </Route>
          <Route path="/order/:id" render={ (props) => <OrderDetails {...props}/> }/>
          <Route path="/invoice">
            <Invoice />
          </Route>
          <Route path="/business">
            <Business />
          </Route>
          <Route path="/calculator" render={ (props) => <Calculator {...props} /> } />
          <Route path="/tracking">
            <OrderStatus />
          </Route>
          <Route path="*">
            return <Redirect to="/" />
          </Route>
        </Switch>
     </div>
  </Router>

  );
}

export default App;
